const template = require('./filter_checklist.html.slim')
declare var angular
import { findIndex, isNaN, isEmpty, filter, map, merge } from 'lodash'

export class FilterChecklist {
  static $inject = ['$rootScope', '$location', '$timeout']

  listChecked: boolean = false
  query
  noTranslate

  private location
  private _list: any[]

  constructor(private $rootScope, private $location, private $timeout) {
    this.location = $location

    $rootScope.$on('deselectFilterTriggered', (() => {
      this.uncheckAll()
    }));

    this.checkListItemsFromQuery(this.list)
  }

  /**
   * Trigger a click to close the tooltip
   *
   * @param {Object} el
   */
  public closeTooltip(el: Object): void {
    this.$timeout(function() {
      angular.element(el).find('.filter-checklist-label').click();
    })
  }

  /**
   * Uncheck all selected checkboxes
   */
  public uncheckAll(): void {
    for (var item of this.list) {
      if (item.checked) { item.checked = undefined }
    }
    this.updateFilters()
  }

  /**
   * Update the query parameter with the checked checkboxes
   */
  public updateFilters(): void {
    var checked = filter(this.list, {'checked': true})
    var checkedList = map(checked, 'value')
    this.listChecked = (checkedList.length > 0)

    var query = {}
    query[this.query] = checkedList
    this.location.search(this.query, null)
    this.location.search( merge( this.location.search(), query ) )
  }

  get list() { return this._list }
  set list(value) {
    // Only convert lists that are arrays and that have been loaded
    if (!isEmpty(value) && !(value[0] instanceof Object)) {
      this._list = this.convertList(value)
    } else {
      this._list = value
    }

    // Only check preselected when list is loaded
    if ( !isEmpty(value) ) {
      this.checkListItemsFromQuery(this._list)
    }
  }

  /**
   * Get list items that are checked from query params
   *
   * @private
   */
  private checkListItemsFromQuery(list): void {
    if (this.location) {
      var checkedItems = this.location.search()[this.query]
      if (this.location === undefined || isEmpty( checkedItems ) ) { return }

      if ( checkedItems instanceof Array ) {
        for (var item of checkedItems) {
          let parsedItem = parseInt(item)
          let value = isNaN(parsedItem) ? item : parsedItem
          let listItemIndex = findIndex(list, {value: value})
          if (listItemIndex > -1) { list[listItemIndex].checked = true }
        }
      } else {
        let listItemIndex = findIndex(list, {value: checkedItems})
        if (listItemIndex > -1) { list[listItemIndex].checked = true }
      }

      if (checkedItems.length > 0) { this.listChecked = true }
    }
  }

  /**
   * Convert an array of single values into an array of list objects
   *
   * @private
   * @param {any} list
   * @returns A converted list that is an array of list objects
   */
  private convertList(list) {
    var results = []
    for (var item of list) {
      results.push({ value: item, name: item })
    }
    return results
  }
}

angular.module('wbComponents').directive('wbFilterChecklist', function() {
  return {
    restrict: 'E',
    controller: FilterChecklist,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      query: '@',
      list: '=',
      noTranslate: '=?'
    },
    templateUrl: template,
  };
});
